<template>
  <div>
    <div class="flex items-center flex-col sm:flex-row justify-center text-center mb-[34px]">
      <a
        class="block sm:inline-block b2 text-zyxel-gray-800 mb-4 sm:mb-0 sm:mr-[62px]"
        href="https://www.zyxel.com/global/en/legal-notice"
        target="_blank"
      >{{ $t('messages.footer.legal_notice') }}</a>
      <a
        class="block sm:inline-block b2 text-zyxel-gray-800 mb-4 sm:mb-0 sm:mr-[62px]"
        href="https://www.zyxel.com/global/en/terms-of-use"
        target="_blank"
      >{{ $t('messages.footer.terms_of_use') }}</a>
      <a
        class="block sm:inline-block b2 text-zyxel-gray-800 mb-4 sm:mb-0 sm:mr-[62px]"
        href="https://www.zyxel.com/global/en/privacy-policy"
        target="_blank"
      >{{ $t('messages.footer.privacy') }}</a>
      <button
        type="button"
        class="block sm:inline-block b2 text-zyxel-gray-800 cursor-pointer"
        @click="openCookieSetting"
      >
        {{ $t('messages.footer.cookie_settings') }}
      </button>
    </div>
    <span class="flex text-center justify-center b3 text-zyxel-gray-800 mb-5">{{ version || '1.0.0' }} {{ $t('messages.footer.copyright') }} {{ new Date().getFullYear() || '2023' }} {{ $t('messages.footer.copyright_clam') }}</span>
  </div>
</template>
<script>
export default {
    name: 'ZyxelFooter',
    data() {
        return {
            version: process.env.VUE_APP_VERSION
        }
    },
    methods: {
        openCookieSetting() {
            const route = this.$router.resolve({ name: 'CookieSetting' });
            window.open(route.href, '_blank');
        }
    }
}
</script>
